import { Contract } from 'cpie-common';
import { DefaultBusinessMarketApiErrorCode } from '@cp-shared-15/common-utilities';
import { AbstractDataState, useGetSimpleApiData } from '@cp-shared-15/frontend-integration';
import { fetchContracts } from './ContractsSlice';
import { ContractsDataSelector } from './ContractsDataSelector';

export function useContracts(): AbstractDataState<Contract[], DefaultBusinessMarketApiErrorCode> {
    return useGetSimpleApiData(fetchContracts, ContractsDataSelector);
}
